<template>
  <div v-if="detalle && isObject(detalle) && !isEmptyObject(detalle)">
    <b-card>
      <titleSection
        title="Acerca de"
        subtitle="Información relacionada a la especialidad"
        icon="InfoIcon"
      />

      <div>
        <h5 class="text-primary mb-75 mt-2">
          <b>Objetivo</b>
        </h5>
        <!-- eslint-disable vue/no-v-html -->
        <div v-html="detalle.objetivo" />
        <!-- eslint-enable -->
      </div>
    </b-card>

    <b-row cols="12">
      <b-col
        xl="6"
        md="12"
      >
        <b-card>
          <h5 class="text-primary mb-75">
            <b>Perfil de ingreso</b>
          </h5>
          <!-- eslint-disable vue/no-v-html -->
          <div v-html="detalle.perfil_ingreso" />
          <!-- eslint-enable -->
        </b-card>
      </b-col>
      <b-col
        xl="6"
        md="12"
      >
        <b-card>
          <h5 class="text-primary mb-75">
            <b>Perfil de egreso</b>
          </h5>
          <!-- eslint-disable vue/no-v-html -->
          <div v-html="detalle.perfil_egreso" />
          <!-- eslint-enable -->
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
} from 'bootstrap-vue'
import { isObject, isEmptyObject } from '@core/utils/utils'
import titleSection from '@/views/components/title-section.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    titleSection,
  },
  props: {
    detalle: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isObject,
      isEmptyObject,
    }
  },
}
</script>
